import { Link } from "react-router-dom";
import { ArrowUpRight, Eye } from "lucide-react";
import { motion } from "framer-motion";

const CAT_LABEL = { rice: "Rice", spices: "Spices", tea: "Tea" };

export default function ProductCard({ product, onQuickView, index = 0 }) {
  const img = product.images?.[0];
  return (
    <motion.article
      data-testid={`product-card-${product.slug}`}
      className="group relative flex flex-col bg-white border border-forest/10 overflow-hidden"
      initial={{ opacity: 0, y: 26 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.6, delay: (index % 4) * 0.07, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="relative aspect-[4/3] overflow-hidden clip-frame-sm bg-forest/5">
        {img && (
          <img
            src={img}
            alt={`${product.name} — AnVibes Exports`}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
        )}
        <span className="absolute left-3 top-3 bg-forest/85 backdrop-blur px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-gold-light">
          {CAT_LABEL[product.category] || product.category}
        </span>
        {onQuickView && (
          <button
            onClick={() => onQuickView(product)}
            data-testid={`quick-view-${product.slug}`}
            className="absolute right-3 top-3 flex h-9 w-9 items-center justify-center bg-parchment/90 text-forest opacity-0 transition-all duration-300 group-hover:opacity-100 hover:bg-gold"
            aria-label={`Quick view ${product.name}`}
          >
            <Eye className="h-4 w-4" />
          </button>
        )}
      </div>
      <div className="flex flex-1 flex-col p-5">
        <h3 className="font-serif text-xl text-forest leading-snug">{product.name}</h3>
        <p className="mt-2 text-sm text-[#4A554D] leading-relaxed line-clamp-2 flex-1">{product.short_description}</p>
        <div className="mt-4 flex items-center gap-2">
          <Link
            to={`/products/${product.slug}`}
            data-testid={`view-details-${product.slug}`}
            className="inline-flex items-center gap-1.5 border border-forest/20 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-forest transition-colors hover:border-gold hover:text-gold-dark"
          >
            View Details
          </Link>
          <Link
            to={`/quote?product=${encodeURIComponent(product.name)}&category=${product.category}`}
            data-testid={`request-quote-${product.slug}`}
            className="inline-flex items-center gap-1 bg-forest px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-parchment transition-colors hover:bg-forest-leaf"
          >
            Request Quote <ArrowUpRight className="h-3.5 w-3.5" />
          </Link>
        </div>
      </div>
    </motion.article>
  );
}
